import { Injectable, EventEmitter } from '@angular/core';


import { IPropertyCard } from '../../shared/models/propertycard';
import { RestService } from '../providers/rest.service';

@Injectable()
export class HomeService extends RestService {

    // Get top three featured properties
    getTopThreeFeaturedProperties(loggedinUserId: number) {
        return this.GET('property/featuredProperties/' + loggedinUserId );
    }

    //Get top three properties based on Asset Type
    getTopThreePropertiesByAssetType(assetTypeId: number, loggedinUserId: number) {
        return this.post<IPropertyCard>("property/assetTypes/" + assetTypeId + "/" + loggedinUserId, '');
    }

    getFeaturedNews() {
        
        return this.GET('common/FeaturedNews');
       
    }
}
